/**
 * Single receipt-logo resolver — used by the Receipt Preview, the POS and
 * every physical print path (native USB bridge, ePOS raster, browser
 * dialog) so they always show the SAME logo.
 *
 * Priority: Branch Logo → Global (company) Logo. Nothing else.
 */
export function resolveReceiptLogoUrl(branding, branch) {
  return (
    branch?.branch_logo_url ||
    branding?.branch_logo_url ||
    branding?.logo_url ||
    ''
  );
}

/** True when src decodes to a real image of at least 10x10 px. Blank
 *  dots / tracking-pixel-sized images are rejected so they never block
 *  the real logo or crash the thermal head. */
export function isPrintableLogo(src) {
  if (!src) return Promise.resolve(false);
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.naturalWidth >= 10 && img.naturalHeight >= 10);
    img.onerror = () => resolve(false);
    img.src = src;
  });
}

/** Async resolver with the built-in size guard: walks the priority chain
 *  and returns the first candidate that is a real >=10x10 image. */
export async function resolveReceiptLogo(branding, branch) {
  const candidates = [
    branch?.branch_logo_url,
    branding?.branch_logo_url,
    branding?.logo_url,
  ].filter(Boolean);
  for (const c of candidates) {
    // eslint-disable-next-line no-await-in-loop
    if (await isPrintableLogo(c)) return c;
  }
  return '';
}
